import PropTypes from 'prop-types';
import Navigation from 'component/Navigation';
const menuItems = [
  { label: 'About', link:' https://www.natureanalytics.earth/about.html' },
  { label: 'Platform' , link:' https://www.natureanalytics.earth/platform.html'},
  { label: 'Glossary', link:'/pages/glossary' },
  { label: 'Help', link:'/pages/help' },
];
const menuItemsMobile = [
  { label: 'Map', link:'/entry/map' },
  { label: 'About', link:' https://www.natureanalytics.earth/about.html' },
  { label: 'Platform' , link:' https://www.natureanalytics.earth/platform.html'},
  { label: 'Glossary', link:'/pages/glossary' },
  { label: 'Help', link:'/pages/help' },
];
const Header = ({ triggerTour }) => {
  return (
    <Navigation triggerTour={triggerTour} menuItems={menuItems} menuItemsMobile={menuItemsMobile}/>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func
};

export default Header;
